import { ref, computed, watch, nextTick } from "vue-demi";
import "../utils/logVersion.js";
import "../axios/selfAxios.js";
import "../utils/opGetProductionByIds.js";
import "../qiankun/action.js";
import "../utils/bodySize.js";
import "../utils/getActivityLabel.js";
import "../utils/getDict.js";
import "axios-interceptor";
import { debounce } from "lodash-es";
import { getOssUrl } from "../utils/getOssUrl.js";
import "js-base64";
import "jszip";
import "../utils/windowSize.js";
import "../utils/currentUserIsGroup.js";
import "../utils/opPostBatchQueryActivityTypeByCondition.js";
import "../utils/getShowConfigButton.js";
import { checkResponseType, ResponseType } from "../utils/checkResponseType.js";
import QRCode from "qrcode";
import "../external/type.js";
import "../external/kujiale/initKujiale.js";
import { jumpFeishuSupportDesk } from "../feishu/jumpFeishuSupportDesk.js";
import { shouldShowFeishuSupportDeskGuide } from "../feishu/feishuSupportDeskGuide.js";
function escapeHtml(input) {
  return input.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
function escapeAttr(input) {
  return escapeHtml(input).replace(/`/g, "&#96;");
}
function buildSupportDeskLink(message) {
  const escapedMessage = escapeAttr(message);
  const actionLabel = "\u67E5\u770B\u64CD\u4F5C\u6307\u5F15";
  return `<a href="javascript:void(0);" class="op-utils-feishu-support-desk-link" data-feishu-support-desk-message="${escapedMessage}">${actionLabel}</a>`;
}
function renderBackendMessage(raw) {
  const text = typeof raw === "string" ? raw : raw == null ? "" : String(raw);
  if (!text)
    return "";
  const tokenRe = /\[(link|qrcode):([^\]|]+)(?:\|([^\]]+))?\]/g;
  let lastIndex = 0;
  let html = "";
  let m;
  while (m = tokenRe.exec(text)) {
    const [full, kind, urlRaw, labelRaw] = m;
    const start = m.index;
    const end = start + full.length;
    if (start > lastIndex) {
      html += escapeHtml(text.slice(lastIndex, start));
    }
    const url = (urlRaw || "").trim();
    if (kind === "link") {
      const label = (labelRaw || url).trim();
      if (url) {
        html += `<a href="${escapeAttr(url)}" target="_blank" rel="noopener noreferrer" class="op-utils-backend-link">${escapeHtml(label)}</a>`;
      } else {
        html += escapeHtml(full);
      }
    } else {
      if (url) {
        const safeUrl = escapeAttr(url);
        html += `<a href="${safeUrl}" target="_blank" rel="noopener noreferrer" class="op-utils-backend-qrcode-link"><img class="op-utils-backend-qrcode" data-op-qrcode-url="${safeUrl}" alt="qrcode" /></a>`;
      } else {
        html += escapeHtml(full);
      }
    }
    lastIndex = end;
  }
  if (lastIndex < text.length) {
    html += escapeHtml(text.slice(lastIndex));
  }
  return html;
}
function useCheckResponseType(Message, options) {
  var _a;
  const businessNoticeResponse = ref([]);
  const businessErrorResponse = ref([]);
  const systemErrorResponse = ref([]);
  const businessNoticeResponseIndex = ref(0);
  const businessErrorResponseIndex = ref(0);
  const systemErrorResponseIndex = ref(0);
  const isShowing = ref(false);
  const tipsImg = getOssUrl({ url: "/MTDS/Public/message/tips.png", envMode: "pro" });
  const allErrorResponse = computed(() => [...businessNoticeResponse.value, ...businessErrorResponse.value, ...systemErrorResponse.value]);
  const isShowQA = computed(() => {
    return systemErrorResponse.value.length > 0;
  });
  const renderMessage = () => {
    var _a2;
    const allErrors = allErrorResponse.value.map((resp) => ({
      code: resp.data.code,
      message: resp.data.message,
      time: resp.__errorTime || 0
    })).sort((a, b) => b.time - a.time);
    const supportDeskGuideEnabled = (_a2 = options == null ? void 0 : options.showSupportDeskGuide) != null ? _a2 : false;
    const shouldShowSupportDeskGuide = supportDeskGuideEnabled && shouldShowFeishuSupportDeskGuide(window.location.href);
    businessNoticeResponseIndex.value = businessNoticeResponse.value.length;
    businessErrorResponseIndex.value = businessErrorResponse.value.length;
    systemErrorResponseIndex.value = systemErrorResponse.value.length;
    const firstError = allErrors[0];
    const moreErrors = allErrors.slice(1);
    const dynamicMessage = `
    <style>
      .more-errors-axios-message .el-message__closeBtn {
        color: #333 !important;
        font-size: 24px !important;
        font-weight: bold !important;
        opacity: 1 !important;
      }
      .more-errors-axios-message {
        z-index: 9999 !important;
      }
      .more-errors-axios-message .op-utils-backend-link {
        color: #409EFF;
        text-decoration: underline;
      }
      .more-errors-axios-message .op-utils-backend-qrcode {
        width: 120px;
        height: 120px;
        display: inline-block;
        vertical-align: middle;
        margin: 0 4px;
        background: #fff;
        border: 1px solid #eee;
      }
      .more-errors-axios-message .op-utils-backend-qrcode-link {
        display: inline-block;
      }
      .more-errors-axios-message .op-utils-feishu-support-desk-link {
        color: #409EFF;
        text-decoration: underline;
        cursor: pointer;
        display: inline-block;
        margin-left: 8px;
      }
    </style>
    <div style="width: 100%; max-width: 800px;">
      <div style="padding: 0 10px; box-sizing: border-box;">
        ${firstError ? `<div style="max-width: 800px">
                <span style="font-weight:bold;font-size:16px;word-wrap:break-word;line-height: 1.3em;">\u9519\u8BEF\u4FE1\u606F\uFF1A${renderBackendMessage(firstError.message || "")}${shouldShowSupportDeskGuide ? buildSupportDeskLink(firstError.message || "") : ""}</span><br/>
                <div style="display: flex;">
                  <div style="flex: 1;line-height: 2em;">
                    <p  style="margin-top: 10px;">\u9519\u8BEF\u7801\uFF1A${firstError.code}</p>
                    ${isShowQA.value ? `
                        <p>\u8BF7\u5C06\u8BE5\u4FE1\u606F\u544A\u77E5\u7B54\u7591\u7EC4</p>
                        <p>\u8054\u7CFB\u65B9\u5F0F\uFF1A020-86614353</p>
                        <p style="margin-top: 10px;font-weight:500;font-size:16px;color: #fc9153; line-height: 1.3em;">MTDS\u7CFB\u7EDF\u7B54\u7591\u8BF7\u70B9\u51FB\u754C\u9762\u53F3\u4E0B\u65B9\u7684\u7B54\u7591\u673A\u5668\u4EBA\u8FDB\u5165\u5728\u7EBF\u5BA2\u670D\u5E73\u53F0</p>` : ""}
                  </div>
                  ${isShowQA.value ? `<div style="margin-top: 10px;text-align: center;width: 130px;padding-right:20px;box-sizing: content-box;">
                          <img style="width: 140px;height: 140px;" src="${tipsImg}">
                        </div>` : ""}
                </div>
              </div>` : "<div>\u6682\u65E0\u9519\u8BEF\u4FE1\u606F</div>"}
        ${moreErrors.length > 0 ? `<div style="border-top: 1px solid #ddd; margin-top: 10px;">
                <a id="more-errors-axios-a"
                 href="javascript:void(0);"
                  style="color: #409EFF; padding: 10px 0; display: block;"
                  onclick="
                    const moreErrors = document.getElementById('more-errors-axios');
                    const toggleBtn = this;
                    if (moreErrors.style.display === 'none') {
                      moreErrors.style.display = 'block';
                      toggleBtn.textContent = '\u6536\u8D77(${moreErrors.length})';
                    } else {
                      moreErrors.style.display = 'none';
                      toggleBtn.textContent = '\u70B9\u51FB\u67E5\u770B\u66F4\u591A(${moreErrors.length})';
                    }">\u70B9\u51FB\u67E5\u770B\u66F4\u591A(${moreErrors.length})</a>
                <div id="more-errors-axios" style="display: none; max-height: 200px; overflow-y: auto;">
                  ${moreErrors.map((error) => `<div style="padding: 5px 0;line-height: 1.3em;">\u9519\u8BEF\u7801\uFF1A${escapeHtml(error.code)}\uFF0C\u9519\u8BEF\u4FE1\u606F\uFF1A${renderBackendMessage(error.message)}${shouldShowSupportDeskGuide ? buildSupportDeskLink(error.message || "") : ""}</div>`).join("")}
                </div>
              </div>` : ""}
      </div>
    </div>`;
    return dynamicMessage;
  };
  async function hydrateQrcodeImages() {
    const container = document.querySelector(".more-errors-axios-message");
    if (!container)
      return;
    const imgs = Array.from(container.querySelectorAll("img[data-op-qrcode-url]"));
    if (imgs.length === 0)
      return;
    await Promise.all(imgs.map(async (img) => {
      const url = img.getAttribute("data-op-qrcode-url");
      if (!url)
        return;
      const existingSrc = img.getAttribute("src");
      if (existingSrc && existingSrc.startsWith("data:image/"))
        return;
      try {
        const dataUrl = await QRCode.toDataURL(url, {
          width: 240,
          margin: 1
        });
        img.setAttribute("src", dataUrl);
      } catch (e) {
      }
    }));
  }
  let messageInstance = null;
  let autoCloseTimer = null;
  const autoCloseDuration = (_a = options == null ? void 0 : options.duration) != null ? _a : 1e4;
  let isMoreOpen = false;
  function startAutoClose() {
    clearAutoClose();
    autoCloseTimer = setTimeout(() => {
      if (messageInstance && !isMoreOpen) {
        messageInstance.close();
      }
    }, autoCloseDuration);
  }
  function clearAutoClose() {
    if (autoCloseTimer) {
      clearTimeout(autoCloseTimer);
      autoCloseTimer = null;
    }
  }
  const handleMoreClick = function() {
    const moreErrors = document.getElementById("more-errors-axios");
    isMoreOpen = !!(moreErrors && moreErrors.style.display === "block");
    if (isMoreOpen) {
      clearAutoClose();
    } else {
      startAutoClose();
    }
  };
  const handleSupportDeskClick = async function(ev) {
    ev.preventDefault();
    const target = ev.currentTarget;
    const message = (target == null ? void 0 : target.getAttribute("data-feishu-support-desk-message")) || "";
    if (!message)
      return;
    try {
      await jumpFeishuSupportDesk({ message });
    } catch (error) {
      console.error(error);
    }
  };
  const updateMessage = debounce(() => {
    if (messageInstance) {
      nextTick(() => {
        const currentElements = document.querySelector(".more-errors-axios-message");
        if (currentElements) {
          const contentEl = currentElements.querySelector(".el-message__content");
          if (contentEl) {
            contentEl.innerHTML = renderMessage();
            hydrateQrcodeImages();
            const moreBtn = document.getElementById("more-errors-axios-a");
            if (moreBtn) {
              moreBtn.removeEventListener("click", handleMoreClick);
              moreBtn.addEventListener("click", handleMoreClick);
            }
            const supportDeskLinks = currentElements.querySelectorAll(".op-utils-feishu-support-desk-link");
            supportDeskLinks.forEach((link) => {
              link.removeEventListener("click", handleSupportDeskClick);
              link.addEventListener("click", handleSupportDeskClick);
            });
            const moreErrors = document.getElementById("more-errors-axios");
            isMoreOpen = !!(moreErrors && moreErrors.style.display === "block");
            if (!isMoreOpen) {
              startAutoClose();
            } else {
              clearAutoClose();
            }
          }
        }
      });
    } else {
      showMessage();
    }
  }, 300);
  watch(allErrorResponse, (newValue) => {
    if (newValue.length > 0 && Message) {
      if (isShowing.value && messageInstance) {
        const moreErrors = document.getElementById("more-errors-axios");
        if (moreErrors && moreErrors.style.display === "block")
          return;
      }
      updateMessage();
    }
  });
  const showMessage = () => {
    try {
      if (isShowing.value || !Message)
        return;
      isShowing.value = true;
      messageInstance = Message({
        message: renderMessage(),
        type: "error",
        duration: 0,
        showClose: true,
        onClose: () => {
          isShowing.value = false;
          messageInstance = null;
          clearAutoClose();
          systemErrorResponse.value = systemErrorResponse.value.slice(systemErrorResponseIndex.value);
          businessErrorResponse.value = businessErrorResponse.value.slice(businessErrorResponseIndex.value);
          businessNoticeResponse.value = businessNoticeResponse.value.slice(businessNoticeResponseIndex.value);
        },
        dangerouslyUseHTMLString: true,
        customClass: "more-errors-axios-message"
      });
      nextTick(() => {
        hydrateQrcodeImages();
        const moreBtn = document.getElementById("more-errors-axios-a");
        if (moreBtn) {
          moreBtn.removeEventListener("click", handleMoreClick);
          moreBtn.addEventListener("click", handleMoreClick);
        }
        const supportDeskLinks = document.querySelectorAll(".more-errors-axios-message .op-utils-feishu-support-desk-link");
        supportDeskLinks.forEach((link) => {
          link.removeEventListener("click", handleSupportDeskClick);
          link.addEventListener("click", handleSupportDeskClick);
        });
        const moreErrors = document.getElementById("more-errors-axios");
        isMoreOpen = !!(moreErrors && moreErrors.style.display === "block");
        if (!isMoreOpen) {
          startAutoClose();
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  function checkAxiosResponseType(response) {
    if (response.status !== 200)
      return;
    const {
      data: { code },
      config: { url }
    } = response;
    if (!url)
      return;
    const responseType = checkResponseType(url, code);
    response.__errorTime = Date.now();
    switch (responseType) {
      case ResponseType.BUSINESS_NOTICE: {
        businessNoticeResponse.value.push(response);
        break;
      }
      case ResponseType.BUSINESS_ERROR: {
        businessErrorResponse.value.push(response);
        break;
      }
      case ResponseType.SYSTEM_ERROR: {
        systemErrorResponse.value.push(response);
        break;
      }
    }
    return responseType;
  }
  return {
    checkAxiosResponseType,
    businessNoticeResponse,
    businessErrorResponse,
    systemErrorResponse
  };
}
export { useCheckResponseType };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/use/useCheckResponseType.js